export default function getAutomation(state) {
  return state.automation;
}